import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Chip, Box, FormControlLabel, Checkbox } from '@mui/material';
import { QueryParameterKeys } from '../../../globals/paramter';
import fileTypeFilters, { FilterSet } from './default-filters';
import { parametersAsObject, urlUpdate } from '../../../globals/utils';
import { TransactionType } from '../../../entities/transactions-v1/query-types';

const ActiveFilters = (
  properties: {
    vimsDataFilter?: string;
    page?: string;
  }
) => {
  const { vimsDataFilter, page } = properties;
  const history = useHistory();
  const parameters: URLSearchParams = new URLSearchParams(history.location.search);
  const activeCategories = parameters.get(QueryParameterKeys.category) || undefined;
  const fileTypeIdFilters = parameters.get(QueryParameterKeys.fileTypeIdFilters) || undefined;
  const excludeFileTypeIdFilters = parameters.get(QueryParameterKeys.excludeFileTypeIdFilters);
  const [customFilters, setCustomFilters] = useState<string | null>();
  const vimsData = parameters.get(QueryParameterKeys.vimsData) || vimsDataFilter?.toString() || undefined;
  const [vimsFilter, setVimsFilter] = useState<string | null>();
  const viewFileSize = parameters.get(QueryParameterKeys.viewFileSize) || undefined;
  const[viewFileSizeValue,setViewFileSizeValue]= useState<string|null>();

  const toggleActiveFilter = (fileTypeFilter: TransactionType) => {
    let newActiveCategories = activeCategories;
    if (newActiveCategories && newActiveCategories.includes(fileTypeFilter))
      newActiveCategories = newActiveCategories.replace(`${fileTypeFilter},`, '');
    else newActiveCategories = `${newActiveCategories || ''}${fileTypeFilter},`;
    urlUpdate(history, parametersAsObject(parameters), {
      category: newActiveCategories || null,
    });
  };

  const toggleCustomFilters = () => {
    if (!customFilters && fileTypeIdFilters) {
      setCustomFilters(fileTypeIdFilters);
      const filetTypes = customFilters || null;
      urlUpdate(history, parametersAsObject(parameters), {
        fileTypeIdFilters: filetTypes,
      });
    } else if (!customFilters && excludeFileTypeIdFilters) {
      setCustomFilters(excludeFileTypeIdFilters);
      const filetTypes = customFilters || null;
      urlUpdate(history, parametersAsObject(parameters), {
        excludeFileTypeIdFilters: filetTypes,
      });
    }
    else {
      setCustomFilters(null);
      urlUpdate(history, parametersAsObject(parameters), {
        fileTypeIdFilters: null,
        excludeFileTypeIdFilters: null,
      });
    }
  };

  const toggleVimsFilters = () => {
    if (!vimsData) {
      setVimsFilter(vimsFilter);
      urlUpdate(history, parametersAsObject(parameters), {
        vimsData: 'true',
      });
    } else {
      setVimsFilter(null);
      urlUpdate(history, parametersAsObject(parameters), {
        vimsData: null
      });
    }
  };

  const toggleViewFileSize = () => {
    if (!viewFileSize) {
      setViewFileSizeValue(viewFileSizeValue);
      urlUpdate(history, parametersAsObject(parameters), {
        viewFileSize: 'true',
      });
    }
    else {
      setViewFileSizeValue(null);
      urlUpdate(history, parametersAsObject(parameters), {
        viewFileSize: null
      });
    }
  };

  return (
    <Box display="inline-flex">
      <Box style={{ display: 'flex', width: 'auto' }}>
        {page === 'transation' && (
          <>
            {fileTypeFilters.map((fileTypeFilter: FilterSet) => (
              <Box key={fileTypeFilter.title} p={0.5} pb={0}>
                <Chip
                  id={`filter-Chip-${fileTypeFilter.title}`}
                  size="small"
                  label={fileTypeFilter.title}
                  clickable
                  onClick={() => toggleActiveFilter(fileTypeFilter.activeFileTypeFilter)}
                  variant={
                    activeCategories?.includes(fileTypeFilter.activeFileTypeFilter)
                      ? 'filled'
                      : 'outlined'
                  }
                />
              </Box>
            ))}
            {(fileTypeIdFilters || excludeFileTypeIdFilters || customFilters) && (
              <Box key="custom-filter" p={0.5} pb={0}>
                <Chip
                  id="filter-Chip-Custom-Filter"
                  size="small"
                  label="Custom Filter"
                  clickable
                  onClick={() => toggleCustomFilters()}
                  variant={fileTypeIdFilters || excludeFileTypeIdFilters || !customFilters ? 'filled' : 'outlined'}
                />
              </Box>
            )}
            <FormControlLabel
              control={<Checkbox
                id="chip-vims-data"
                size="small"
                onClick={() => toggleVimsFilters()}
                checked={vimsData === "true"}
              />}
              label="VIMS SFTP Data Files"
              labelPlacement="start"
            />
          </>
        )}
        <FormControlLabel
          control={<Checkbox
            id="chip-vims-data"
            size="small"
            onClick={() => toggleViewFileSize()}
            checked={viewFileSize === "true"}
          />}
          label="View File Size"
          labelPlacement="start"
        />
      </Box>
    </Box>
  );
};
export default ActiveFilters;
